import React, { ForwardRefRenderFunction, PropsWithChildren } from 'react';
import Card from '../../../../common/Card/Card';
import { Stack, Typography } from '@mui/material';

interface CartProductCategoryProps {
  title?: string,
}

const CartProductCategory: ForwardRefRenderFunction<HTMLDivElement, PropsWithChildren<CartProductCategoryProps>> = (
  { children, title },
  ref
) => {

  return (
    <div ref={ref}>
      <Card sx={(theme) => ({ 
        padding: '40px',
        [theme.breakpoints.down('laptop')]: {
          padding: '20px'
        }
        })}>
        <Stack direction="column" spacing={4}>
          <Typography
            color="#ED1C24"
            textTransform="uppercase"
            variant="primaryFont"
            letterSpacing='4px'
            fontSize={20}>
            {title}
          </Typography>
          <Stack
            direction="column"
            spacing={2}>
            {children}
          </Stack>
        </Stack>
      </Card>
    </div>
  );
};

const ForwardedCartProductCategory = React.forwardRef(CartProductCategory)

export default ForwardedCartProductCategory;
